<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 512 512"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0,512) scale(0.1,-0.1)" fill="#BFBFBF" stroke="none">
      <path
        d="M1887 5099 c-25 -13 -44 -34 -57 -62 -34 -72 -622 -2456 -617 -2499 6 -48 38 -91 81 -112 29 -14 82 -16 390 -16 196 0 356 -2 356 -4 0 -3 -187 -505 -415 -1117 -228 -612 -415 -1125 -415 -1141 0 -74 75 -148 149 -148 81 0 26 -70 1311 1701 665 917 1215 1681 1224 1697 35 67 8 150 -60 189 -38 22 -46 23 -371 23 -183 0 -333 2 -333 4 0 2 167 285 371 628 204 342 380 640 390 660 10 21 19 51 19 68 0 50 -35 107 -80 130 -38 20 -56 20 -972 20 -913 -1 -934 -1 -971 -21z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
